module.exports = __webpack_public_path__ + "static/img/0009.3752044.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImages/bottom/0009.png
// module id = x239
// module chunks = 3